import React from 'react';

import { InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

type ParentProps = {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function VisibilityAdornment({
  showPassword,
  setShowPassword,
}: ParentProps): JSX.Element {
  const toggleShowPassword: VoidFunction = () => {
    setShowPassword(previous => !previous);
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>): void => {
    // Keep focus in the password input while toggling visibility.
    event.preventDefault();
  };

  return (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={toggleShowPassword}
        onMouseDown={handleMouseDown}
        edge="end"
        size="small"
        type="button"
      >
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );
}
